import Vue from 'vue';

/**
 * Global Definitions
 */
 import Diary from './components/index';

 /**
  * Global Definitions
  * Local Components Which we have control off.
  */

 /** --------- */
 Vue.component("icon",                Diary.Icons.FontAwesomeIcon);

   /** Controls --------- */
 Vue.component("accordion", Diary.Controls.accordion);

  /** Charts --------- */
  Vue.component("barChart", Diary.Charts.barChart);

  /** Elements --------- */
  Vue.component("pageHeader", Diary.Elements.pageHeader);
  Vue.component("modal", Diary.Elements.modal);
//   Vue.component("detailsHeader", Dem.Elements.detailsHeader);
//   Vue.component("backButton", Dem.Elements.backButton);

//  /** Layout --------- */
Vue.component("Home", Diary.Layouts.Home);
Vue.component("intro", Diary.Layouts.intro);
Vue.component("statements", Diary.Layouts.statements);
Vue.component("entryAdded", Diary.Layouts.entryAdded);
Vue.component("noEntriesAdded", Diary.Layouts.noEntriesAdded);
Vue.component("myWellbeingDiary", Diary.Layouts.myWellbeingDiary);
Vue.component("statementDetails", Diary.Layouts.statementDetails);
Vue.component("share", Diary.Layouts.share);
Vue.component("helpAndSupport", Diary.Layouts.helpAndSupport);



 export default {};